import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    mapearParametrosEAnexosSei(contratoId, boletimMedicaoId, payload = {}) {
        return axiosJwt
            .post(
                `${api}/fornecedor/contratos/${contratoId}/boletins-medicao/${boletimMedicaoId}/integracao-sei/mapear`,
                payload
            )
            .then(response => response.data)
            .catch(error => errorHandler(error))
    },

    enviarDocumentoIndividualParaSei(contratoId, boletimMedicaoId, payload = {}) {
        return axiosJwt
            .post(
                `${api}/fornecedor/contratos/${contratoId}/boletins-medicao/${boletimMedicaoId}/integracao-sei/enviar-documento`,
                payload
            )
            .then(response => response.data)
            .catch(error => errorHandler(error))
    },

    registrarEnvioSeiHistorico(contratoId, boletimMedicaoId, resultados = []) {
        return axiosJwt
            .post(
                `${api}/fornecedor/contratos/${contratoId}/boletins-medicao/${boletimMedicaoId}/historico/envio-sei`,
                { resultados }
            )
            .then(response => response.data)
            .catch(error => errorHandler(error))
    }
}
